import {ConfirmationConfig} from './confirmation-dialog';

export const CONFIRMATION_PRESETS: Record<string, ConfirmationConfig> = {
    delete: {
        title: "deleteConfirmation.heading",
        description: "deleteConfirmation.defaultMessage",
        cancelButton: {
            text: "deleteConfirmation.buttons.cancel.text",
            ariaLabel: "deleteConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "deleteConfirmation.buttons.submit.text",
            ariaLabel: "deleteConfirmation.buttons.submit.ariaLabel",
            color: "red"
        }
    },
    cancel: {
        title: "cancelConfirmation.heading",
        description: "cancelConfirmation.defaultMessage",
        cancelButton: {
            text: "cancelConfirmation.buttons.cancel.text",
            ariaLabel: "cancelConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "cancelConfirmation.buttons.submit.text",
            ariaLabel: "cancelConfirmation.buttons.submit.ariaLabel",
            color: "orange"
        }
    },
    archive: {
        title: "archiveConfirmation.heading",
        description: "archiveConfirmation.defaultMessage",
        cancelButton: {
            text: "archiveConfirmation.buttons.cancel.text",
            ariaLabel: "archiveConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "archiveConfirmation.buttons.submit.text",
            ariaLabel: "archiveConfirmation.buttons.submit.ariaLabel",
            color: "amber"
        }
    },
    deactivate: {
        title: "deactivateConfirmation.heading",
        description: "deactivateConfirmation.defaultMessage",
        cancelButton: {
            text: "deactivateConfirmation.buttons.cancel.text",
            ariaLabel: "deactivateConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "deactivateConfirmation.buttons.submit.text",
            ariaLabel: "deactivateConfirmation.buttons.submit.ariaLabel",
            color: "yellow"
        }
    },
    activate: {
        title: "activateConfirmation.heading",
        description: "activateConfirmation.defaultMessage",
        cancelButton: {
            text: "activateConfirmation.buttons.cancel.text",
            ariaLabel: "activateConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "activateConfirmation.buttons.submit.text",
            ariaLabel: "activateConfirmation.buttons.submit.ariaLabel",
            color: "green"
        }
    },
    export: {
        title: "exportConfirmation.heading",
        description: "exportConfirmation.defaultMessage",
        cancelButton: {
            text: "exportConfirmation.buttons.cancel.text",
            ariaLabel: "exportConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "exportConfirmation.buttons.submit.text",
            ariaLabel: "exportConfirmation.buttons.submit.ariaLabel",
            color: "blue"
        }
    },
    reset: {
        title: "resetConfirmation.heading",
        description: "resetConfirmation.defaultMessage",
        cancelButton: {
            text: "resetConfirmation.buttons.cancel.text",
            ariaLabel: "resetConfirmation.buttons.cancel.ariaLabel"
        },
        confirmButton: {
            text: "resetConfirmation.buttons.submit.text",
            ariaLabel: "resetConfirmation.buttons.submit.ariaLabel",
            color: "purple"
        }
    }
};

export type ConfirmationPreset = keyof typeof CONFIRMATION_PRESETS;
